export const blockIconsMapsWhereToVoteNew = (
	<span className='material-symbols-outlined'>where_to_vote</span>
);
